import { useFetch } from '../../../hooks';
import { getBillingLastRefreshedDate } from '../../../api';

export const useBillingLastRefreshedDate = () => {
  const { data: lastRefreshedDate, loading: isLastRefreshedDateLoading } =
    useFetch(async () => await getBillingLastRefreshedDate(), []);

  return {
    lastRefreshedDate,
    isLastRefreshedDateLoading,
  };
};
